import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { LoginActivate } from "./services/login-activate.service";

const routes: Routes = [
  {
    path: "",
    loadChildren: () =>
      import("./components/tabs/tabs.module").then((m) => m.TabsPageModule),
  },
  {
    path: "connexion",
    loadChildren: () =>
      import("./pages/connexion/connexion.module").then(
        (m) => m.ConnexionPageModule
      ),
  },
  {
    path: "missions-detail/:id",
    canActivate: [LoginActivate],
    loadChildren: () =>
      import("./pages/missions-detail/missions-detail.module").then(
        (m) => m.MissionsDetailPageModule
      ),
    data: { animation: "MissionsDetail" },
  },
  {
    path: "missions-filters",
    canActivate: [LoginActivate],
    loadChildren: () =>
      import("./pages/missions-filters/missions-filters.module").then(
        (m) => m.MissionsFiltersPageModule
      ),
  },
  {
    path: "actions-enattente",
    canActivate: [LoginActivate],
    loadChildren: () =>
      import("./pages/actions-enattente/actions-enattente.module").then(
        (m) => m.ActionsEnattenteModule
      ),
  },
  {
    path: "campagnes-proposees",
    canActivate: [LoginActivate],
    loadChildren: () =>
      import("./pages/campagnes-proposees/campagnes-proposees.module").then(
        (m) => m.CampagnesProposeesPageModule
      ),
  },
  {
    path: "campagnes-filters",
    canActivate: [LoginActivate],
    loadChildren: () =>
      import("./pages/campagnes-filters/campagnes-filters.module").then(
        (m) => m.CampagnesFiltersPageModule
      ),
  },
  {
    path: "ma-facturation",
    canActivate: [LoginActivate],
    loadChildren: () =>
      import("./pages/ma-facturation/ma-facturation.module").then(
        (m) => m.MaFacturationPageModule
      ),
  },
  {
    path: "facturation-filters",
    canActivate: [LoginActivate],
    loadChildren: () =>
      import("./pages/facturation-filters/facturation-filters.module").then(
        (m) => m.FacturationFiltersPageModule
      ),
  },
  {
    path: "mes-prefacturations",
    canActivate: [LoginActivate],
    loadChildren: () =>
      import("./pages/mes-prefacturations/mes-prefacturations.module").then(
        (m) => m.MesPrefacturationsPageModule
      ),
  },
  {
    path: "prefacture",
    canActivate: [LoginActivate],
    loadChildren: () =>
      import("./pages/prefacture/prefacture.module").then(
        (m) => m.PrefacturePageModule
      ),
  },
  {
    path: "constat-lecture",
    canActivate: [LoginActivate],
    loadChildren: () =>
      import("./pages/constat-lecture/constat-lecture.module").then(
        (m) => m.ConstatLecturePageModule
      ),
  },
  {
    path: "survey",
    canActivate: [LoginActivate],
    loadChildren: () =>
      import("./pages/survey/survey.module").then((m) => m.SurveyPageModule),
  },
  {
    path: "forgot-password",
    loadChildren: () =>
      import("./pages/forgot-password/forgot-password.module").then(
        (m) => m.ForgotPasswordPageModule
      ),
  },
  {
    path: "test",
    loadChildren: () =>
      import("./pages/test/test.module").then((m) => m.TestPageModule),
  },
  {
    path: "infos-pdv",
    canActivate: [LoginActivate],
    loadChildren: () =>
      import("./pages/infos-pdv/infos-pdv.module").then(
        (m) => m.InfosPdvPageModule
      ),
  },
  {
    path: "campagne-horsfichier/:id",
    canActivate: [LoginActivate],
    loadChildren: () =>
      import("./pages/campagne-horsfichier/campagne-horsfichier.module").then(
        (m) => m.CampagneHorsFichierPageModule
      ),
  },
  {
    path: "pdv-select/:id",
    canActivate: [LoginActivate],
    loadChildren: () =>
      import("./pages/pdv-select/pdv-select.module").then(
        (m) => m.PdvSelectPageModule
      ),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
